import Image from 'next/image';
import { useEffect, useState, useContext } from 'react';

// hooks
import { useSegmentViewEvents } from 'hooks/useSegmentView';
import { useViewport } from 'utils/responsive';

// context
import { MPosContext } from 'utils/context';

// utils
import { getImageBasePath } from 'utils/generics';
import {
    SegmentEventNameTypes,
    SegmentEventPageTypes,
    SegmentEventPages,
    PRODUCT,
    SUB_PRODUCT_NAME,
} from 'utils/segment/constants';
import { getCommissionAmount } from './api';

import * as Styles from './styles';

interface IProps {
    partner: string;
}
const CommissionEarned: React.FC<IProps> = (props) => {
    const { partner } = props;
    const { partnerId } = useContext(MPosContext);

    const [loading, setLoading] = useState<boolean>(true);
    const [amount, setAmount] = useState<number>(0);
    const { isMobile } = useViewport();

    const getAmount = async () => {
        const response = await getCommissionAmount(partner);
        setAmount(response.amount);
        setLoading(false);
    };

    useEffect(() => {
        getAmount();
    }, []);

    /**
     * view segment hook
     */
    useSegmentViewEvents(SegmentEventNameTypes.VIEW, {
        page_url: typeof window !== 'undefined' ? window.location.href : '',
        page_type: SegmentEventPageTypes.MAIN_PAGE,
        view_name: SegmentEventPages.VIEW_COMMISSIONS_EARNED_V1_PAGE,
        product: PRODUCT,
        sub_product_name: SUB_PRODUCT_NAME,
        platform: isMobile ? 'mweb' : 'web',
        referrer: document.referrer || '',
        device: navigator.userAgent || '',
        partner: partnerId,
    });

    return (
        <Styles.Wrapper>
            <Styles.IconWrapper>
                <Image
                    src={getImageBasePath('/icons/wallet.svg')}
                    alt=""
                    width={'32px'}
                    height={'32px'}
                />
            </Styles.IconWrapper>
            <Styles.TextBoxWrapper>
                <Styles.Text>Today&apos;s Earnings</Styles.Text>
                {loading ? (
                    <Styles.LoaderWrapper>
                        <Image
                            src={getImageBasePath('/gif/greenCircleLoader.gif')}
                            alt="..."
                            width={'20px'}
                            height={'20px'}
                        />
                    </Styles.LoaderWrapper>
                ) : (
                    <Styles.Text>Rs. {amount}</Styles.Text>
                )}
            </Styles.TextBoxWrapper>
        </Styles.Wrapper>
    );
};

export default CommissionEarned;
